import { destroyCookie, parseCookies, setCookie } from 'nookies';
import { CookieOptions } from '../../entities';
import { CookiesService } from './CookiesService';

export class CookiesClientService implements CookiesService {
  private options: CookieOptions;

  constructor(options: CookieOptions = {}) {
    this.options = options;
  }

  set(key: string, value: string, options: CookieOptions = {}) {
    const mergedOptions = { ...this.options, ...options };
    setCookie(null, key, value, mergedOptions);
  }

  get(key: string): string | undefined {
    const cookies = parseCookies(null);
    return cookies[key];
  }

  getAll(): Record<string, string> {
    return parseCookies(null);
  }

  remove(key: string, options: CookieOptions = {}) {
    const mergedOptions = { ...this.options, ...options };
    destroyCookie(null, key, mergedOptions);
  }
}
